module.exports = __webpack_public_path__ + "static/media/restore.600ce1e8.png";